import { InputAdornment, OutlinedInput } from "@mui/material";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const StyledLabel = styled.label`
  font-weight: 600;
  color: var(--header-text);
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

export const InputNumber = ({
  prefix,
  label,
  errorMessage,
  name,
  control,
  placeholder,
  max,
  maxLength,
  readOnly = false,
  thousandSeparator = ",",
}) => {
  return (
    <Container>
      <StyledLabel>{label}</StyledLabel>
      <Controller
        name={name}
        control={control}
        render={({ field, field: { onChange, name, value } }) => (
          <NumericFormat
            {...field}
            readOnly={readOnly}
            allowLeadingZeros
            thousandSeparator={thousandSeparator}
            customInput={OutlinedInput}
            size="small"
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            startAdornment={
              <InputAdornment position="start">{prefix}</InputAdornment>
            }
          />
        )}
        rules={{ required: true, min: 0, max, maxLength }}
      />
      <ErrorMessage>
        {errorMessage === "required" ? "Campo obligatorio" : ""}
        {errorMessage === "min" ? "Ingresa un valor correcto" : ""}
        {errorMessage === "max" ? "Ingresa un valor correcto" : ""}
        {errorMessage === "maxLength" ? "Ingresa un valor correcto" : ""}
      </ErrorMessage>
    </Container>
  );
};
